import cn from 'classnames'
import Link, { LinkProps } from 'next/link'
import React from 'react'
import { ConditionalWrap } from './ConditionalWrap'
import { TabsView } from './Tabs'

export interface TabProps {
	active?: boolean
	onClick: (
		event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
	) => void
	label: string
	view?: TabsView
	linkProps?: LinkProps
}

export const Tab: React.FunctionComponent<TabProps> = ({
	active,
	label,
	onClick,
	view,
	linkProps,
}) => {
	const className = cn(
		'tab',
		{ 'is-active': active },
		`view-${view || TabsView.default}`,
	)

	return (
		<ConditionalWrap
			condition={Boolean(linkProps)}
			wrap={(children) => (
				<Link {...linkProps!}>
					<a className={className} onClick={onClick}>
						{children}
					</a>
				</Link>
			)}
		>
			<ConditionalWrap
				condition={!Boolean(linkProps)}
				wrap={(children) => (
					<button className={className} onClick={onClick} type="button">
						{children}
					</button>
				)}
			>
				<>{label}</>
			</ConditionalWrap>
		</ConditionalWrap>
	)
}
